import React from "react";
import ReactDom from "react-dom";

import SiteHeaderBase from "./SiteHeaderBase.jsx";

export default () => {
  document.querySelectorAll(".js-site-header__mount").forEach((el, i) => {
    const data = JSON.parse(el.dataset.model || {});
    const dictionary = JSON.parse(el.dataset.dictionary || {});

    // if (data.theme === "base") {
    ReactDom.render(<SiteHeaderBase {...data} dictionary={dictionary} />, el);
    // }
  });
};
